import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminUsers, AdminUserNew, AdminUserShow, AdminUserEdit } from 'containers'

export const AdminUserRouter = () => {
  return (
    <Routes>
      <Route path="/new" element={<AdminUserNew />} />
      <Route path="/:slug" element={<AdminUserShow />} />
      <Route path="/:slug/edit" element={<AdminUserEdit />} />
      <Route path="/" element={<AdminUsers />} />
    </Routes>
  )
}
